import { render, staticRenderFns } from "./FileDetails.vue?vue&type=template&id=3030ccdf&"
import script from "./FileDetails.vue?vue&type=script&lang=js&"
export * from "./FileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports